import React from 'react';
import { Search, X } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';

const ReservaFilters = ({
  busqueda,
  setBusqueda,
  filtroAnio,
  setFiltroAnio,
  filtroEstado,
  setFiltroEstado,
  limpiarFiltros,
  aniosDisponibles,
  estadosReserva,
  totalReservas,
  reservasFiltradas
}) => {
  return (
    <div className="card-beach mb-6">
      <div className="flex flex-col lg:flex-row gap-4 items-start lg:items-center justify-between">
        <div className="flex flex-col sm:flex-row gap-4 flex-1 w-full lg:w-auto">
          {/* Búsqueda */}
          <div className="relative flex-1 min-w-[200px]">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-[#0E3A53]/40 w-4 h-4" />
            <Input
              placeholder="Buscar por nombre de huésped..."
              value={busqueda}
              onChange={(e) => setBusqueda(e.target.value)}
              className="pl-10"
              data-testid="search-input"
            />
          </div>
          
          {/* Filtro por año */}
          <Select value={filtroAnio} onValueChange={setFiltroAnio}>
            <SelectTrigger className="w-[140px]" data-testid="filter-year">
              <SelectValue placeholder="Año" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="todos">Todos los años</SelectItem>
              {aniosDisponibles.map(anio => (
                <SelectItem key={anio} value={anio.toString()}>{anio}</SelectItem>
              ))}
            </SelectContent>
          </Select>
          
          {/* Filtro por estado */}
          <Select value={filtroEstado} onValueChange={setFiltroEstado}>
            <SelectTrigger className="w-[180px]" data-testid="filter-status">
              <SelectValue placeholder="Estado" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="todos">Todos los estados</SelectItem>
              {estadosReserva.map(estado => (
                <SelectItem key={estado.id_estado} value={estado.nombre}>
                  {estado.nombre}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          
          {/* Limpiar filtros */}
          {(busqueda || filtroAnio || filtroEstado) && (
            <Button 
              variant="outline" 
              onClick={limpiarFiltros}
              className="text-[#FF7F6A] border-[#FF7F6A] hover:bg-[#FF7F6A]/10"
              data-testid="clear-filters"
            >
              <X className="w-4 h-4 mr-1" />
              Limpiar
            </Button>
          )}
        </div>
        
        {/* Contador de resultados */}
        <div className="text-sm text-[#0E3A53]/60">
          Mostrando <span className="font-semibold text-[#1AA1D8]">{reservasFiltradas}</span> de{' '}
          <span className="font-semibold">{totalReservas}</span> reservas
        </div>
      </div>
    </div>
  );
};

export default ReservaFilters;
